export const menuData = {
    public: [
        { path: "/restaurants", icon: "/Navigation/fastfoodIcon.png", label: "Restaurants" },
        { path: "/activities", icon: "/Navigation/activityIcon.png", label: "Activités" },
        { path: "/beauty", icon: "/Navigation/beautyIcon.png", label: "Bien-être & Spa" },
        { path: "/cars", icon: "/Navigation/carsIcon.png", label: "Services auto" },
        { path: "/alimentation", icon: "/Navigation/alimentationIcon.png", label: "Epiceries" },
        { path: "/about", icon: "/Navigation/aboutIcon.png", label: "À propos" },
    ],
    client: [
        { path: "/restaurants", icon: "/Navigation/fastfoodIcon.png", label: "Restaurants" },
        { path: "/activities", icon: "/Navigation/activityIcon.png", label: "Activités" },
        { path: "/beauty", icon: "/Navigation/beautyIcon.png", label: "Bien-être & Spa" },
        { path: "/cars", icon: "/Navigation/carsIcon.png", label: "Services auto" },
        { path: "/alimentation", icon: "/Navigation/alimentationIcon.png", label: "Epiceries" },
        { path: "/about", icon: "/Navigation/aboutIcon.png", label: "À propos" },
    ],
    trader: [
        { path: "/trader", icon: "/Navigation/espaceIcon.png", label: "Mon espace" },
        { path: "/trader/offers", icon: "/Navigation/offersIcon.png", label: "Mes offres" },
        { path: "/trader/pass", icon: "/Navigation/espaceIcon.png", label: "Mon Pass" },
        { path: "/about", icon: "/Navigation/aboutIcon.png", label: "À propos" },
    ],
    admin: [
        { path: "/admin", icon: "/Navigation/adminIcon.png", label: "Administrateur" },
        { path: "/about", icon: "/Navigation/aboutIcon.png", label: "À propos" },
    ],
};
